<template lang="pug">
  nuxt
</template>

<script>
export default {
  middleware: ["sessionHandler"]
}
</script>
